import _keycloak from '@/services/Auth/keycloakInstance'
import WhiteLabelService from '@/services/WhiteLabel/WhiteLabelService'
import OauthProviderService from '@/services/OauthProvider/OauthProviderService'
import { store as STORE } from '@/store'

const IDENTITY_PROVIDER_MODULE_NAME = 'identity-provider'

async function initKeycloak() {
	await WhiteLabelService.loadWhiteLabelData()
	await OauthProviderService.getOauthProviders()

	const identityProviderModuleIsActive = STORE.state.modules.list.some(module => module.name === IDENTITY_PROVIDER_MODULE_NAME)

	if (!identityProviderModuleIsActive) {
		return
	}

	await _keycloak.init({
		onLoad: 'check-sso',
		pkceMethod: 'S256'
	})
}

export function startAfterKeycloakInit(onReady) {
	return initKeycloak().finally(() => onReady())
}

const Plugin = {
	install: Vue => {
		Object.defineProperties(Vue.prototype, {
			$keycloak: {
				get() {
					return _keycloak
				}
			}
		})
	}
}

export default Plugin